import React from 'react';
import styles from './TopBar4.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar4 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.container}>
        
        {/* Left Side: Contact info */}
        <div className={styles.contactGroup}>
          <div className={styles.contactBox}>
            <FaPhoneAlt className={styles.leadIcon} />
            <div className={styles.details}>
              <small className={styles.label}>Call Us</small>
              <span className={styles.value}>{phone}</span>
            </div>
          </div>

          <div className={styles.contactBox}>
            <FaEnvelope className={styles.leadIcon} />
            <div className={styles.details}>
              <small className={styles.label}>Email Us</small>
              <span className={styles.value}>{email}</span>
            </div>
          </div>
        </div>

        {/* Right Side: Social Icons */}
        <div className={styles.socialGroup}>
          <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.ghostButton}>
            <FaFacebookF />
          </a>

          <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.ghostButton}>
            <FaInstagram />
          </a>

          <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.ghostButton}>
            <FaTwitter />
          </a>
        </div>

      </div>
    </div>
  );
};

export default TopBar4;